
<template>
  <div class="d-flex  full align-center justify-center">
    <div class="d-flex flex-wrap" v-if="guides">
      <span v-for="guide in guides" :key="guide.fullName">
        {{ guide.fullName }}
      </span>

    </div>
    <div class="d-flex align-content-center">
      <v-btn icon
      @click="openGuideDialog">
        <v-icon> {{ guides ? 'mdi-pencil' : 'mdi-plus' }} </v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    guides: {
      type: Array
    },
  },
  methods: {
    openGuideDialog() {
      this.$emit('start-editing-dialog');
    }
  }
};
</script>
